import React from 'react';
import PropTypes from 'prop-types';
import { CustomInput, InputFieldContainer, InputLabel } from './InputField.style';
import  FormError  from '../FormError/FormError';

const InputField = ({ isError, errorMessage, label, required, ...rest }) => {
  return (
    <InputFieldContainer>
      <InputLabel htmlFor={rest.name}>
        {label}
        {required && <span className="required">*</span>}
      </InputLabel>
      <CustomInput {...rest} $isError={isError} />
      {isError && <FormError message={errorMessage} />}
    </InputFieldContainer>
  );
};

InputField.propTypes = {
  /**
   * To hide and show the error message
   */
  isError: PropTypes.bool,

  /**
   * Display error message when it is enabled
   */
  errorMessage: PropTypes.string,
  /**
   * Input label
   */
  label: PropTypes.string.isRequired,
  /**
   * Whether the field is required
   */
  required: PropTypes.bool,
};

InputField.defaultProps = {
  isError: false,
  errorMessage: '',
  label: 'Input Label',
  required: false,
};
export default InputField;